<template>
  <div class="page-container">
    <Goback></Goback>
    <DonatePopup v-model="showDonatePopup" :refer="itemId" v-if="itemId"></DonatePopup>
    <ItemActionStatsEmit :delay="3000" action="view" :itemId="itemId" itemType="video" :key="itemId" v-if="itemId && !showLoading"></ItemActionStatsEmit>

    <div class="item-full-container">
      <div class="video-container">
        <div class="video-player-container" v-if="showVideoBox">
          <div id="xg"></div>
        </div>
        <div class="video-cover-box" @click="onClickPlayVideo" v-else>
          <img class="img-video-cover" :src="item.cover_url"/>
        </div>
        <div class="play-icon" v-if="!showVideoBox && !showExchangeBtn" @click="onClickPlayVideo">
          <img class="play-icon" src="https://a1.wanwanshequ.com/static/public/play.png"/>
        </div>
        <div class="after-free-try-tip" v-if="showUnlockAfterTryFree">试看结束</div>
        <div class="unlock-desc-container" @click="onClickExchange" v-if="showExchangeBtn">
          <img class="play-icon-unlock" src="https://a1.wanwanshequ.com/static/public/89c3705ffd940f1a.png"/>
          <div class="unlock-text">{{creditChangeButtonText}}</div>
        </div>
        <div class="free-try-tip" v-if="showFreeTry">试看前{{getDuration(item.preview_duration)}}</div>
        <div class="duration" v-if="showVideoDuration"> {{getDuration(item.duration)}}</div>
      </div>

      <div class="item-display-text-container">
        <div class="item-title-container">
          {{item.title}}
        </div>
      </div>

      <div class="action-bar-container">
        <div class="actions">
          <div class="action-item">
            <Favorite :item="item" v-if="itemId"></Favorite>
          </div>
        </div>
        <div class="change-line-btn-container">
          <cube-button @click="onClickChangeLineButton" :inline="true" class="btn-change-line">切换线路</cube-button>
          <ChangeLineActions ref="changeLineAction" @changeLine="onChangeLine"></ChangeLineActions>
        </div>
      </div>

      <div class="video-recommend-container" v-if="recommendLookItemList && recommendLookItemList.length > 0">
        <div class="tab-user-album" @click="onClickAlbum">
          <div>查看专辑</div>
          <div>
            <Icon name="arrow"></Icon>
          </div>
        </div>
        <div class="tab-item">
          <div class="item" v-for="item in recommendLookItemList" :key="item.id" @click="showCrawlItem(item)">
            <div class="item-detail">
              <div class="img-container">
                <img :src="item.cover_url" alt="">
                <div class="duration"> {{getDuration(item.duration)}}</div>
              </div>
              <div class="desc">
                <div class="description"> {{getTitle(item)}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CommentInfo :itemId="itemId" v-if="itemId"></CommentInfo>
    </div>
  </div>
</template>

<script>
  import {Dialog, Popup, Icon, Switch, Button, Notify, Toast} from "vant"
  import Player from 'xgplayer';
  import ChangeLineActions from "../../common/ChangeLineActions";
  import Goback from "../../common/Goback";
  import DonatePopup from "../../common/DonatePopup";
  import {IsApp} from "../../../util/common";
  import Favorite from "../../common/Favorite";
  import CommentInfo from "../../comment/CommentInfo";
  import ItemActionStatsEmit from "../../common/ItemActionStatsEmit";

  export default {
    name: "VideoDetail",
    components: {
      ItemActionStatsEmit,
      CommentInfo,
      Favorite,
      DonatePopup,
      Goback, ChangeLineActions,
      Popup, Button, Icon, [Switch.name]: Switch, Dialog, Notify, Toast,
    },

    data() {
      return {
        isLogin: true,

        player: null,
        showLoading: true,
        isVideoPlaying: false,

        item: {},
        showDetail: false,
        itemId: 0,
        iconName: "arrow-left",
        recommendLookItemList: [],
        showShareTip: false,

        afterTryFree: false,
        showLoginPopup: false,
        showDonatePopup: false,

        showPopupSettings: false,
      };
    },
    mounted() {
      this.itemId = parseInt(this.$route.params.id)
      this.init()
      this.getCachedUserInfo()
      this.initRecommend()
    },
    methods: {
      getCachedUserInfo() {
        this.$store.dispatch("CacheAccountInfoMine").then((data) => {
          if (data && data.id) {
            this.isLogin = true
          } else {
            this.isLogin = false
          }
        }, () => {
        })
      },

      onClickAlbum() {
        this.$router.push("/user_album/" + this.item.user.id)
      },

      initVideoInfo() {
        this.isVideoPlaying = false
        this.afterTryFree = false

        if (this.player) {
          try {
            this.player.destroy();
          } catch (e) {
            console.log(e)
          }
        }

        let checkExist = setInterval(() => {
          let xg = document.getElementById("xg")
          if (xg) {
            this.player = null;
            this.player = new Player({
              id: 'xg',
              fitVideoSize: 'auto',
              url: this.item.video_url,
              poster: this.item.cover_url,
              fluid: true,
              lang: 'zh-cn',
            });
            this.player.on('timeupdate', this.onTimeupdate)
            this.player.on('play', () => {
              this.isVideoPlaying = true
            })
            clearInterval(checkExist);
          }
        }, 100);
      },

      async init() {
        this.item = {}
        let q = this.$route.query

        let queries = {}
        for (let i in q) {
          queries[i] = q[i]
        }
        queries.id = this.itemId

        this.showLoading = true
        await this.$store.dispatch("GetUgcItem", queries).then((data) => {
              if (data.code !== 0) {
                Toast.fail("内容不存在")
              } else {
                this.item = data.data;
                if (this.showVideoBox) {
                  this.initVideoInfo()
                }
              }
            }, () => {
              Toast.fail("网络错误")
            }
        );
        this.showLoading = false
      },

      onClickChangeLineButton() {
        this.$refs.changeLineAction.showChangeLine()
      },

      showCrawlItem(item) {
        this.itemId = item.id
        this.init()
        window.scrollTo(0, 0)
      },

      getDuration(t) {
        if (Math.floor(t / 3600) > 0) {
          return ('0' + Math.floor(t / 3600) % 24).slice(-2) + ':' + ('0' + Math.floor(t / 60) % 60).slice(-2) + ':' + ('0' + t % 60).slice(-2)
        } else {
          return ('0' + Math.floor(t / 60) % 60).slice(-2) + ':' + ('0' + t % 60).slice(-2)
        }
      },
      getTitle(item) {
        if (!item || !item.title) {
          return ""
        }
        return item.title
      },
      getNickName(item) {
        if (!item || !item.user) {
          return ""
        }
        return item.user.nickname
      },
      initRecommend() {
        let queries = {
          "item_id": this.itemId,
        }
        this.$store.dispatch("GetRelatedItem", queries).then((data) => {
          if (data.code === 0) {
            this.recommendLookItemList = data.data
          }
        }, (error) => {
          console.log(error)
        })
      },

      onTimeupdate() {
        let currentTime = this.player.currentTime
        if (currentTime > this.previewDuration && this.showNeedAuth) {
          this.afterTryFree = true
          this.player.pause()
        }
      },

      onShowDetail() {
        if (this.iconName === "arrow-left") {
          this.iconName = "arrow-down"
          this.showDetail = true
        } else {
          this.iconName = "arrow-left"
          this.showDetail = false
        }
      },
      onAuthorInfo() {
        let userId = 0
        if (this.item && this.item.user && this.item.user.id) {
          userId = this.item.user.id
          this.$router.push("/author/" + userId)
        }
      },

      onClickPlayVideo() {
        if (this.useNativePlayer && !this.showNeedAuth) {
          if (this.item.video_url) {
            window.injectedObject.startVideoPlayer(this.item.video_url)
          }
        }
      },

      onClickExchange() {
        if (!this.isLogin) {
          this.$router.push("/login")
          return
        }

        this.$createDialog({
          type: 'confirm',
          content: `确认解锁`,
          confirmBtn: {
            text: '确定',
            active: true,
            href: 'javascript:;'
          },
          cancelBtn: {
            text: '取消',
            active: false,
            disabled: false,
            href: 'javascript:;'
          },
          onConfirm: () => {
            this.doExchange()
          },
          onCancel: () => {
          }
        }).show()
      },


      doExchange() {
        let params = {
          item_id: '' + this.itemId,
          item_type: "look",
        };

        this.$store.dispatch("ExchangeCredit", params).then((data) => {
          if (data.code === 0) {
            this.$createToast({
              txt: `解锁成功`,
              type: "text",
              time: 1000,
            }).show()
            this.init()
          } else if (data.code === 20010) {
            this.$router.push("/login")
          } else if (data.code === 30001) {
            this.showDonatePopup = true
          } else {
            this.$createToast({
              txt: `系统错误`,
              type: "error",
              time: 1000,
            }).show()
          }
        }, (error) => {
          console.log(error)
        })
      },

      onChangeLine() {
        this.init()
      }
    },
    computed: {
      useNativePlayer() {
        if (this.showNeedAuth) {
          return false
        }

        if (IsApp() && window.injectedObject && window.injectedObject.startVideoPlayer) {
          return true
        } else {
          return false
        }
      },

      showVideoBox() {
        if (!this.isLogin) {
          return false
        }

        if (this.afterTryFree) {
          return false
        }

        if (this.showNeedUnlock) {
          return false
        }

        if (this.useNativePlayer) {
          return false
        }

        return true
      },

      showVideoDuration() {
        if (this.item && this.item.id && !this.isVideoPlaying) {
          return true
        }
        return false
      },

      showUnlockAfterTryFree() {
        if (this.afterTryFree) {
          return true
        } else {
          return false
        }
      },

      showExchangeBtn() {
        if (!this.showVideoBox) {
          return this.showNeedAuth;
        }

        return false
      },

      showVideoPlayIcon() {
        if (this.useNativePlayer && !this.showNeedAuth) {
          return true
        } else {
          return false
        }
      },

      // 没有解锁 （可能可以试看）
      showNeedAuth() {
        if (this.item) {
          if (this.item.with_auth === false) {
            return true
          }
        }
        return false
      },

      previewDuration() {
        if (!this.showNeedAuth) {
          return 9999999.0
        }
        if (this.item && this.item.preview_duration) {
          return this.item.preview_duration
        } else {
          return 0
        }
      },

      showFreeTry() {
        if (this.afterTryFree || this.isVideoPlaying) {
          return false
        }

        if (this.showNeedAuth && this.item && this.item.preview_duration > 0) {
          return true
        }
        return false
      },

      // 没有试看 必须解锁
      showNeedUnlock() {
        if (!this.showNeedAuth) {
          return false
        }

        if (this.item && this.item.preview_duration === 0) {
          return true
        } else {
          return false
        }
      },

      creditChangeButtonText() {
        if (!this.isLogin) {
          return "登录/注册"
        }

        if (this.item && this.item.credit) {
          return "" + this.item.credit + "币观看"
        }
        return ""
      },
    },
    watch: {}
  };
</script>
<style lang="scss" scoped>
  .page-container {
    background: white;
    min-height: 100vh;
  }

  .item-full-container {
    background: white;

    .comment-container {
      margin-top: 12px;
      color: rgba(34, 34, 34, 0.87);

      .title {
        padding: 5px;
        font-size: 14px;
        color: grey;
      }
    }
  }

  .video-container {
    width: 100%;
    overflow: hidden;
    position: relative;

    .video-player-container {
      z-index: 0;
      width: 100%;
      min-height: 210px;
      background: black;
    }

    .unlock-desc-container {
      z-index: 1000;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      padding: 12px 22px;
      background: rgba(25, 25, 25, 0.8);
      -webkit-border-radius: 15px;
      -moz-border-radius: 15px;
      border-radius: 15px;
      display: flex;
      align-items: center;

      .play-icon-unlock {
        width: 24px;
        height: 24px;
      }

      .unlock-text {
        color: white;
        margin-left: 5px;
        font-size: 16px;
      }
    }

    .video-cover-box {
      width: 100%;
      height: 210px;
      background: black;
      position: relative;

      .img-video-cover {
        z-index: 1000;
        display: block;
        width: 100%;
        height: auto;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }


    .play-icon {
      width: 50px;
      height: 50px;
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 1000;
    }

    .duration {
      z-index: 1000;
      position: absolute;
      right: 8px;
      bottom: 8px;
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      height: 18px;
      min-width: 18px;
      color: #fff;
      border-radius: 5px;
      background: rgba(0, 0, 0, 0.7);
      line-height: 12px;
      text-align: center;
      font-size: 10px;
      padding: 3px 3px;
      vertical-align: bottom;
    }

    .free-try-tip {
      z-index: 1000;

      position: absolute;
      left: 8px;
      bottom: 8px;
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      color: rgba(255, 255, 255, 0.93);
      border-radius: 3px;
      background: rgba(0, 0, 0, 0.7);
      text-align: center;
      font-size: 14px;
      padding: 8px 2px;
      vertical-align: bottom;
    }

    .after-free-try-tip {
      z-index: 1000;

      position: absolute;
      left: 8px;
      bottom: 8px;
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      color: rgba(255, 255, 255, 0.93);
      border-radius: 5px;
      background: rgba(0, 0, 0, 0.7);
      text-align: center;
      font-size: 14px;
      padding: 3px 5px;
      vertical-align: bottom;
    }


  }

  .action-bar-container {
    padding: 8px 12px;
    display: flex;
    align-items: center;

    .actions {
      flex: 1 1 auto;
      font-size: 18px;
      display: flex;
      align-items: center;

      .action-item {
      }

    }

    .change-line-btn-container {
      .btn-change-line {
      }
    }
  }

  .item-display-text-container {
    background: white;
    padding: 8px 0;

    .item-title-container {
      color: #222;
      margin: 0 3px;
      max-height: 5.2em;
      line-height: 1.1em;
      text-overflow: ellipsis;
      font-size: 18px;
      font-weight: bold;
    }
  }

  .video-recommend-container {
    margin-top: 12px;

    .tab-user-album {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 5px 8px;
      color: rgba(34, 34, 34, 0.87);
    }

    .tab-item {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 0 5px;

      .item {
        width: 48%;
        margin-top: 10px;

        .item-detail {
          display: flex;
          flex-direction: column;
          background-color: #fff;

          .duration {
            position: absolute;
            right: 8px;
            bottom: 8px;
            box-sizing: border-box;
            -webkit-box-sizing: border-box;
            height: 18px;
            min-width: 18px;
            color: #fff;
            border-radius: 5px;
            background: rgba(0, 0, 0, 0.7);
            line-height: 12px;
            text-align: center;
            font-size: 10px;
            padding: 3px 3px;
            vertical-align: bottom;
          }

          .img-container {
            /*-webkit-background-size: cover;*/
            /*background-size: cover;*/
            /*border-radius: 5px 5px 0 0;*/
            -webkit-border-radius: 5px;
            -moz-border-radius: 5px;
            border-radius: 5px;
            height: 100px;
            width: 100%;
            background: black;
            align-items: center;
            flex: 0 0 auto;
            position: relative;
            overflow: hidden;
          }

          img {
            width: 100%;
            position: absolute;
            top: 50%;
            left: 50%;
            display: block;
            transform: translate(-50%, -50%);
          }

          .desc {
            color: #9d9d9d;
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin-top: 3px;
            font-size: 12px;
            overflow: hidden;

            .description {
              color: dimgrey;
              overflow: hidden;
              display: block; /* or inline-block */
              text-overflow: ellipsis;
              word-wrap: break-word;
              max-height: 4.5em;
              line-height: 1.5em;
            }

            .user-nickname {
              color: rgba(32, 32, 32, 0.83);
              font-size: 12px;
              margin-top: 12px;
            }
          }
        }
      }
    }
  }

</style>
